import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getFundRequestDetailsByFRId = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;
        
        const response = await axiosApi.post(`/FundRequest/GetFundRequestDetailsByFrId`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getFundRequestDetailsByFRId===>:", error);
    }
};
const getFundRequestList = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/FundRequest/GetFundRequestList`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getFundRequestList===>:", error);
    }
};

const addFundRequest = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/AddFundRequest`, body, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        console.log("Error addFundRequest ===>", error);
    }
};

const updateFundRequest = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/UpdateFundRequest`, body, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        console.log("Error updateFundRequest ===>", error);
    }
};

const approveRejectFundRequest = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/ApproveRejectFundRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error approveRejectFundRequest ===>", error);
        return error?.response?.data;
    }
};

const deleteFundRequestItemByItemId = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequestItem/DeleteFundRequestItemByItemId`, body);
        return response?.data;
    } catch (error) {
        console.log("Error deleteFundRequestItemByItemId ===>", error);
        return error?.response?.data;
    }
};

const approveFundRequest = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/ApproveFundRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error approveFundRequest ===>", error);
        return error?.response?.data;
    }
};
const RejectFundRequest = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/RejectFundRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error requestFundRequest ===>", error);
        return error?.response?.data;
    }
};
const deleteFR = async (body) => {
    try {
        const response = await axiosApi.post(`FundRequest/DeleteFundRequest`, body);
        return response?.data;
    } catch (error) {
        console.log("Error deleteFR ===>", error);
        return error?.response?.data;
    }
};

const getRequestAttachmentsByRequestId = async (requestId, requestTypeId) => {
    try {
        const response = await axiosApi.get(`FundRequest/GetAttachmentsByRequestId/` + requestId + `/` + requestTypeId);
        return response?.data;
    } catch (error) {
        console.log("Error getRequestAttachmentsByRequestId===>:", error);
    }
};




async function getFundRequestitemPaymentDetailsByFrIdVendorIdVendorBankId(data) {
    try {
        const response = await axiosApi.post(`/FundRequestItem/GetFundRequestItemDetailsByFRIdAndVendorID/${data?.fundRequestId}/${data?.vendorId}/${data?.vendorBankId}`);
        return response?.data;
    } catch (error) {
        console.log("Error getData By GetFundRequestItemDetailsByFRIdAndVendorID===>:", error);
        return null;
    }
};
export const FundRequestService = {
    getFundRequestList,
    addFundRequest,
    deleteFR,
    updateFundRequest,
    getFundRequestDetailsByFRId,
    approveRejectFundRequest,
    deleteFundRequestItemByItemId,
    approveFundRequest,
    RejectFundRequest,
    getFundRequestitemPaymentDetailsByFrIdVendorIdVendorBankId,
    getRequestAttachmentsByRequestId,
}